import { render, staticRenderFns } from "./incorrect-mappings-modal.vue?vue&type=template&id=ff9ee5e4&scoped=true"
import script from "./incorrect-mappings-modal.vue?vue&type=script&lang=js"
export * from "./incorrect-mappings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9ee5e4",
  null
  
)

export default component.exports